export default [
  {
    path: "/driver/login",
    component: () => import("@/view/pages/auth/Auth"),
    children: [
      {
        path: "",
        name: "driver-login",
        component: () =>
          import("@/modules/driver-access/pages/DriverLogin.vue")
      }
    ],
    meta: { requiresAuth: false }
  },
  {
    path: "/driver",
    component: () => import("@/view/pages/auth/Auth"),
    children: [
      {
        path: "",
        name: "driver-machine",
        component: () =>
          import("@/modules/driver-access/pages/DriverMachine.vue")
      }
    ],
    meta: { requiresAuth: false }
  }
];
